export const UNIT_FILE_FIELDS_URL = "dl-unit/file-fields";
